import { AdditionalPeopleRoleType } from './AdditionalPeopleRoleType';

export const AdditionalPeopleRoleTypeOptions = [
    {
        id: AdditionalPeopleRoleType.Officer,
        text: 'Officer',
    },
    {
        id: AdditionalPeopleRoleType.RegularEmployee,
        text: 'Regular Employee',
    },
];
